import {
  coursesRequest,
  LRS_HEALTH_CHECK_SUCCESS,
  LRS_HEALTH_CHECK_FAILURE,
  START_LRS_HEALTH_CHECK_POLLING,
  STOP_LRS_HEALTH_CHECK_POLLING,
  REQUEST_LESSON_URL,
} from './types';

export {
  requestPlaybookContent,
  requestPlaybookContentFailure,
  requestPlaybookContentSuccess,
} from './playbook/actions';

export const requestCourses = () => ({
  type: coursesRequest.request,
});

export const requestCoursesSuccess = (response) => ({
  type: coursesRequest.success,
  response,
});

export const requestCoursesFailure = (error) => ({
  type: coursesRequest.failure,
  error,
});

export const lrsHealthCheckSuccess = () => ({
  type: LRS_HEALTH_CHECK_SUCCESS,
});

export const lrsHealthCheckFailure = () => ({
  type: LRS_HEALTH_CHECK_FAILURE,
});

export const startLearningHealthCheckPolling = (lessonId, lessonToken) => ({
  type: START_LRS_HEALTH_CHECK_POLLING,
  lessonId,
  lessonToken,
});

export const stopLearningHealthCheckPolling = () => ({
  type: STOP_LRS_HEALTH_CHECK_POLLING,
});

export const requestLessonUrl = (lessonId, promise) => ({
  type: REQUEST_LESSON_URL,
  lessonId,
  promise,
});
